

































































import { Component, Ref, Vue } from 'vue-property-decorator';
import { SystemSettingItem } from '@/store/settings/system_settings/types';
import { Action } from 'vuex-class';
import {cloneDeep, isEqual} from "lodash";
import { notifyError, notifyDelete, notifyConfirm } from '@/utils/notify-helper';
import { InputWings, TextareaWings } from "wings-ui-components";

import { getTranslatedParams } from '@/utils/notify-utils';
import { ActionLog } from '@/store/auth/types';

@Component({components: {InputWings, TextareaWings}})
export default class SystemSetting extends Vue {

  @Ref('validator') validator: any;

  @Action("getSystemSettingItem") actionGetItem: any;
  @Action("saveSystemSettingItem") actionSaveItem: any;
  @Action("deleteSystemSettingItem") actionDeleteItem: any;
  @Action("actionLog") actionLog: any;

  defaultItem(): SystemSettingItem {
    return {
      name: '',
      value: '',
      description: ''
    };
  }

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {}

  get originatorRules() {
    return 'required';
  }

  async created() {
    if (this.$route.params.id) {
      try {
        const data = await this.actionGetItem(this.$route.params.id)
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: 'success',
          object_type: "System setting",
          object_name: data.name
        }
        await this.actionLog(this.logObject)
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
      } catch(err) {
        await this.actionLog({...this.logObject, action_status: 'failed'})
      }
    }
  }

  back(): void {
    this.$router.push('/settings/system_settings/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "System setting",
            object_name: this.item.name,
            addititional_info: getTranslatedParams({value: this.item.value, description: this.item.description})
          }
          await this.actionSaveItem(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject()
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "System setting",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.$route.params.id})
        }
        await this.actionDeleteItem(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

};
